import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import algosdk from "algosdk";
import { useEffect, useState, useRef } from "react";
import "./App.css";

import Login from "./home/Login";
import Register from "./home/Register";
import Home from "./home/Home";
import Wallet from "./pages/Wallet";
import News from "./pages/Noticias";
import Roulette from "./pages/Roulette";
import Referido from "./pages/Referido";
import Eventos from "./pages/Eventos";
import Marketplace from "./pages/Marketplace";
import Proveedores from "./pages/Proveedores";
import Quizz from "./pages/Quizz";
import Stake from "./pages/Stake";
import Target from "./pages/Target";
import { TransactionProvider } from "./context/TransactionContext";
import TransactionModal from "./components/TransactionModal";
import { WalletProvider, useWallet } from "./context/WalletContext";
import { NetworkProvider, useNetwork } from "./context/NetworkContext";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";



const AppContent = () => {
  const { account, logout } = useWallet();
  const { network, algodClient, toggleNetwork, ASA_HLK, ASA_UMQ } = useNetwork();

  const accountAddress = account?.addr || "";

  const [algoBalance, setAlgoBalance] = useState<number>(0);
  const [umqBalance, setUmqBalance] = useState<number>(0);
  const [hlkBalance, setHlkBalance] = useState<number>(0);
  const [username] = useState<string>("");
  const [message, setMessage] = useState<string | null>(null);
  const messageTimeout = useRef<NodeJS.Timeout | null>(null);
  const [isMessageVisible, setIsMessageVisible] = useState(false);

  const handleMessage = (msg: string) => {
    setMessage(msg);
    setIsMessageVisible(true);

    if (messageTimeout.current) clearTimeout(messageTimeout.current);

    messageTimeout.current = setTimeout(() => {
      setIsMessageVisible(false);
      messageTimeout.current = null;
    }, 5500);
  };

const extractTxID = (message: string): string => {
  if (!message) return "";
  const match = message.match(/[A-Z2-7]{52}/); 
  if (match) return match[0];
  
  const genericMatch = message.match(/[A-Z2-7]{32,64}/);
  if (genericMatch) return genericMatch[0];

  return ""; 
};

const shortenString = (str: string, startChars: number = 6, endChars: number = 6): string => {
  if (str.length <= startChars + endChars + 3) return str;
  const start = str.substring(0, startChars);
  const end = str.substring(str.length - endChars);
  return `${start}...${end}`;
};

  useEffect(() => {
    const fetchBalances = async () => {
      if (!accountAddress) return;
      try {
        const info = await algodClient.accountInformation(accountAddress).do();
        setAlgoBalance(info.amount / 1e6);

        const umq = info.assets.find((a: any) => a["asset-id"] === ASA_UMQ);
        const hlk = info.assets.find((a: any) => a["asset-id"] === ASA_HLK);

        setUmqBalance(umq ? umq.amount / 1e9 : 0);
        setHlkBalance(hlk ? hlk.amount / 1e9 : 0);
      } catch (error) {
        console.error("Error obteniendo balances:", error);
      }
    };

    fetchBalances();
    const interval = setInterval(fetchBalances, 5000);
    return () => clearInterval(interval);
  }, [accountAddress, algodClient, ASA_UMQ, ASA_HLK]);

  const fullTxID = extractTxID(message);
  const hasValidTxID = /^[A-Z2-7]{32,64}$/.test(fullTxID);

  let displayMessage;
if (hasValidTxID) {
  const shortTxID = shortenString(fullTxID, 6, 6); 
  displayMessage = message.replace(fullTxID, shortTxID);
} else {
  displayMessage = message;
}

  return (
    <Router>
      {isMessageVisible && message && (
      <div
        className="message"
        onClick={() => {
          if (hasValidTxID) {
            navigator.clipboard.writeText(fullTxID);
            setMessage("📋 TxID copiado");
          }
        }}
        title={hasValidTxID ? "Haz clic para copiar el TxID completo" : undefined}
        style={{
          cursor: hasValidTxID ? "pointer" : "default",
        }}
      >
        {displayMessage} 

        {hasValidTxID && (
          <>
            <br />
            <span className="copy-hint">📋 Copiar</span>
          </>
        )}
      </div>
    )}

      <div className="network-toggle">
        <button
          onClick={toggleNetwork}
          className={`network-button ${network.toLowerCase()}`}
        >
          🌐 {network}
        </button>
      </div>

      <Routes>
         <Route path="/" element={<Login setMessage={handleMessage} logout={logout} />} />
        <Route
  path="/home"
  element={
    <Home
      algodClient={algodClient}
      setMessage={handleMessage}
      account={accountAddress}
      username={username}
      algoBalance={algoBalance}
      umqBalance={umqBalance}
      hlkBalance={hlkBalance}
    />
  }
/>
        <Route path="/login" element={<Login setMessage={handleMessage} logout={logout} />} />
        <Route path="/register" element={<Register setMessage={handleMessage} />} />

        <Route
          path="/home"
          element={
            <Home
              algodClient={algodClient}
              setMessage={handleMessage}
              account={accountAddress}
              username={username}
              algoBalance={algoBalance}
              umqBalance={umqBalance}
              hlkBalance={hlkBalance}
              logout={logout}
            />
          }
        />

        <Route
          path="/quizz"
          element={<Quizz algodClient={algodClient} setMessage={handleMessage} />}
        />

        <Route
          path="/wallet"
          element={<Wallet algodClient={algodClient} setMessage={handleMessage} />}
        />

        <Route
          path="/target"
          element={
            <Target
              algodClient={algodClient}
              setMessage={handleMessage}
              account={accountAddress}
              username={username}
              algoBalance={algoBalance}
              umqBalance={umqBalance}
              logout={logout}
            />
          }
        />

        <Route
          path="/marketplace"
          element={<Marketplace algodClient={algodClient} setMessage={handleMessage} />}
        />
        <Route
          path="/eventos"
          element={<Eventos algodClient={algodClient} setMessage={handleMessage} />}
        />
        <Route path="/proveedores" element={<Proveedores setMessage={handleMessage} />} />
        <Route path="/news" element={<News />} />

        <Route
          path="/roulette"
          element={
            <Roulette
              algodClient={algodClient}
              setMessage={handleMessage}
              account={accountAddress}
              username={username}
              algoBalance={algoBalance}
              umqBalance={umqBalance}
              logout={logout}
            />
          }
        />

        <Route
          path="/referido"
          element={
            <Referido
              algodClient={algodClient}
              setMessage={handleMessage}
              account={accountAddress}
              username={username}
              algoBalance={algoBalance}
              umqBalance={umqBalance}
              logout={logout}
            />
          }
        />

        <Route
          path="/stake"
          element={<Stake algodClient={algodClient} setMessage={handleMessage} />}
        />
      </Routes>

      <Analytics />
      <SpeedInsights />
    </Router>
  );
};


const MoxHolkanApp = () => (
  <WalletProvider>
    <NetworkProvider>
      <TransactionProvider>
        <AppContent />
        <TransactionModal />
      </TransactionProvider>
    </NetworkProvider>
  </WalletProvider>
);

export default MoxHolkanApp;
